import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getApplicationStatusMessageDetailFetchSuccess,
    getApplicationStatusMessageDetailFetchFailure,
    createApplicationStatusMessageDetailFetchSuccess,
    createApplicationStatusMessageDetailFetchFailure,
    updateApplicationStatusMessageDetailFetchSuccess,
    updateApplicationStatusMessageDetailFetchFailure,
} from './reducer';
import { getApplicationStatusMessagesListFetch } from 'src/resources/applicationStatusMessagesList/reducer';
import { ApplicationStatusMessageDetailResType } from 'src/types/applicationStatusMessageDetail';
import { ApplicationStatusMessageType } from 'src/types/applicationStatusMessage';
import translate from '@translate';

const getApplicationStatusMessageDetailFetchRequest = async (idApplicationStatusMessage: string) => {
    const res = await api('get', `api/secure/application-status-messages/${idApplicationStatusMessage}`);
    return res.data.data;
};

function* getApplicationStatusMessageDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ApplicationStatusMessageDetailResType = yield call((): any =>
            getApplicationStatusMessageDetailFetchRequest(action.payload)
        );
        yield put(getApplicationStatusMessageDetailFetchSuccess(response));
    } catch (error) {
        yield put(getApplicationStatusMessageDetailFetchFailure({ error }));
    }
}

export function* getApplicationStatusMessageDetailFetchWatch() {
    yield takeEvery(
        'applicationStatusMessageDetail/getApplicationStatusMessageDetailFetch',
        getApplicationStatusMessageDetailFetch
    );
}

const createApplicationStatusMessageDetailFetchRequest = async (data: ApplicationStatusMessageType) => {
    const res = await api('post', 'api/secure/application-status-messages', data);
    return res.data.data;
};

function* createApplicationStatusMessageDetailFetch(action: { type: string; payload: ApplicationStatusMessageType }) {
    try {
        const response: ApplicationStatusMessageDetailResType = yield call((): any =>
            createApplicationStatusMessageDetailFetchRequest(action.payload)
        );
        yield put(
            createApplicationStatusMessageDetailFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('applicationStatusMessages.message.applicationStatusMessageCreated'),
                },
            })
        );
        yield put(getApplicationStatusMessagesListFetch());
    } catch (error) {
        yield put(createApplicationStatusMessageDetailFetchFailure({ error }));
    }
}

export function* createApplicationStatusMessageDetailFetchWatch() {
    yield takeEvery(
        'applicationStatusMessageDetail/createApplicationStatusMessageDetailFetch',
        createApplicationStatusMessageDetailFetch
    );
}

const updateApplicationStatusMessageDetailFetchRequest = async (params: {
    idApplicationStatusMessage: string;
    data: ApplicationStatusMessageType;
}) => {
    const res = await api(
        'put',
        `api/secure/application-status-messages/${params.idApplicationStatusMessage}`,
        params.data
    );
    return res.data.data;
};

function* updateApplicationStatusMessageDetailFetch(action: {
    type: string;
    payload: { idApplicationStatusMessage: string; data: ApplicationStatusMessageType };
}) {
    try {
        const response: ApplicationStatusMessageDetailResType = yield call((): any =>
            updateApplicationStatusMessageDetailFetchRequest(action.payload)
        );
        yield put(
            updateApplicationStatusMessageDetailFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('applicationStatusMessages.message.applicationStatusMessageUpdate'),
                },
            })
        );
        yield put(getApplicationStatusMessagesListFetch());
    } catch (error) {
        yield put(updateApplicationStatusMessageDetailFetchFailure({ error }));
    }
}

export function* updateApplicationStatusMessageDetailFetchWatch() {
    yield takeEvery(
        'applicationStatusMessageDetail/updateApplicationStatusMessageDetailFetch',
        updateApplicationStatusMessageDetailFetch
    );
}
